const Config = {
  translateLink: true,
  csvHeadRow: [
    'Key（ssg前端）',
    '中文（中文(简体)）',
    '英文（English）',
    '日语（日本語）',
    '韩语（한국어）',
    '繁体中文（中文(繁體)）',
    '西班牙语（ESPAÑOL）',
    '葡萄牙语（PORTUGUÊS）',
    '德语（DEUTSCH）',
    '法语（FRANÇAIS）',
    '俄语（РУССКИЙ）',
    '泰语（thai）'
  ],
  localeMapKey: [
    {
      key: 'zh_CN',
      localeKey: '中文（中文(简体)）'
    },
    {
      key: 'en_US',
      localeKey: '英文（English）'
    },
    {
      key: 'ja_JP',
      localeKey: '日语（日本語）'
    },
    {
      key: 'ko_KR',
      localeKey: '韩语（한국어）'
    },
    {
      key: 'zh_HK',
      localeKey: '繁体中文（中文(繁體)）'
    },
    {
      key: 'es_ES',
      localeKey: '西班牙语（ESPAÑOL）'
    },
    {
      key: 'pt_PT',
      localeKey: '葡萄牙语（PORTUGUÊS）'
    },
    {
      key: 'de_DE',
      localeKey: '德语（DEUTSCH）'
    },
    {
      key: 'fr_FR',
      localeKey: '法语（FRANÇAIS）'
    },
    {
      key: 'ru_RU',
      localeKey: '俄语（РУССКИЙ）'
    },
    {
      key: 'th_TH',
      localeKey: '泰语（thai）'
    }
  ],
  langJsonMapper: {
    'zh-cn': 'zh_CN',
    'zh-tc': 'zh_HK',
    en: 'en_US',
    ja: 'ja_JP',
    ko: 'ko_KR',
    'zh-Hant': 'zh_HK',
    'zh-Hans': 'zh_CN',
    es: 'es_ES',
    pt: 'pt_PT',
    de: 'de_DE',
    fr: 'fr_FR',
    ru: 'ru_RU',
    th: 'th_TH'
  },
  LOCALE_DATA: {
    'zh-cn': () => import(/* webpackChunkName: "locale-zh_CN",  */ '@src/global-locales/build/zh_CN.json'),
    'zh-tc': () => import(/* webpackChunkName: "locale-zh_HK",  */ '@src/global-locales/build/zh_HK.json'),
    en: () => import(/* webpackChunkName: "locale-en_US",  */ '@src/global-locales/build/en_US.json'),
    ja: () => import(/* webpackChunkName: "locale-ja_JP",  */ '@src/global-locales/build/ja_JP.json'),
    ko: () => import(/* webpackChunkName: "locale-ko_KR",  */ '@src/global-locales/build/ko_KR.json'),
    es: () => import(/* webpackChunkName: "locale-es_ES",  */ '@src/global-locales/build/es_ES.json'),
    pt: () => import(/* webpackChunkName: "locale-pt_PT",  */ '@src/global-locales/build/pt_PT.json'),
    de: () => import(/* webpackChunkName: "locale-de_DE",  */ '@src/global-locales/build/de_DE.json'),
    fr: () => import(/* webpackChunkName: "locale-fr_FR",  */ '@src/global-locales/build/fr_FR.json'),
    ru: () => import(/* webpackChunkName: "locale-ru_RU",  */ '@src/global-locales/build/ru_RU.json'),
    'zh-Hant': () => import(/* webpackChunkName: "locale-zh_HK",  */ '@src/global-locales/build/zh_HK.json'),
    'zh-Hans': () => import(/* webpackChunkName: "locale-zh_CN",  */ '@src/global-locales/build/zh_CN.json'),
    th: () => import(/* webpackChunkName: "locale-th_TH",  */ '@src/global-locales/build/th_TH.json')
    // in: () => import(/* webpackChunkName: "locale-id_ID",  */ '@src/global-locales/build/id_ID.json'),
    //"zh-TW": zhTW,
    //"fr-FR": frFr,
    //"ja-JP": jaJP,
  }
};

export default Config;
